import axios from "../axios-auth";
import orginal_axios from "axios";

export const unitService = {
  getUnitList,
  saveUnit,
  getUnitDetail,
  getUnitsByStatus,
  saveUnitExcel,
  getUnitExcelTemplate
};

function getUnitList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return axios.get("/auth/units", { params });
}

function saveUnit(unit) {
  if (!unit.id) {
    // new unit
    return axios.post("/auth/unit", unit);
  } else {
    // edit
    return axios.put("/auth/unit", unit);
  }
}

function getUnitDetail(id) {
  return axios.get("/auth/unit/" + id);
}

function getUnitsByStatus(status) {
  return axios.get("/auth/units-by-status/" + status);
}

function saveUnitExcel(file) {
  return axios.post('/auth/unit-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function getUnitExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/unit-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}
